import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchFacilityTypeAvailability } from '../../data/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const barColors = (values) => values.map(v => v >= 90 ? '#27ae60' : v >= 75 ? '#f39c12' : '#e74c3c');

const StockByFacilityChart = () => {
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    fetchFacilityTypeAvailability().then(r => {
      const top = r.data.filter(d => d.avail !== null).slice(0, 8);
      setLabels(top.map(d => d.name));
      setValues(top.map(d => parseFloat(d.avail)));
    }).catch(console.error);
  }, []);

  const data = {
    labels,
    datasets: [{
      label: 'Availability %', data: values,
      backgroundColor: barColors(values), borderRadius: 4, maxBarThickness: 45
    }]
  };

  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: true, anchor: 'end', align: 'top', color: '#444', font: { weight: '700', size: 10 }, formatter: v => v + '%' }
    },
    scales: {
      x: { grid: { display: false }, ticks: { font: { size: 10 } } },
      y: { min: 50, max: 100, ticks: { font: { size: 10 }, callback: v => v + '%' }, grid: { color: '#f8fafc' } }
    }
  };

  return (
    <div className="chart-box">
      <h3>Stock Availability by Facility Type</h3>
      <div style={{ position: 'relative', minHeight: '300px' }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default StockByFacilityChart;
